import { Navigate, Outlet } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

const RequirePayment = () => {
	const { isUserPaymentValid } = useAuth();

	if (isUserPaymentValid) {
		return <Outlet />;
	} else {
		return <Navigate to='/' />;
	}
};

export default RequirePayment;
